import { useEffect, useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Autocomplete, TextField, TextFieldVariants } from '@mui/material';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import useCachedSpecialitiesList from '@src/adapters/hooks/specialities/useCachedSpecialitiesList';

interface Props {
  name: string;
  control: Control<any>;
  variant?: TextFieldVariants;
}

function SpecialityAutoComplete({ name, control, variant }: Props) {
  const [items, setItems] = useState<IdNameDto[]>([]);

  const { getList } = useCachedSpecialitiesList();

  useEffect(() => {
    getList().then((result) => {
      setItems(result);
    });
  }, [getList]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          options={items}
          freeSolo={false}
          getOptionLabel={(option) => option.name}
          value={items.find((opt) => opt.id === value) || null}
          onChange={(_, newValue) => {
            onChange(newValue ? newValue.id : null);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Speciality" variant={variant} />
          )}
        />
      )}
    />
  );
}

export default SpecialityAutoComplete;
